module.exports = __webpack_public_path__ + "static/media/DL_Card.2c9a7438.png";


//////////////////
// WEBPACK FOOTER
// ./src/components/assign-prescriptions/counter/images/DL_Card.png
// module id = 13169
// module chunks = 0